export default __webpack_public_path__ + "static/blob7-9456cd2c61d38170b9850751f3926770.svg";